export default "__VITE_ASSET__DXWtskJb__"